// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************************************************************
* Copyright (C) 2023 STMicroelectronics and others.
* This program and the accompanying materials are made available under the
* terms of the Eclipse Public License v. 2.0 which is available at
* http://www.eclipse.org/legal/epl-2.0.
*
* This Source Code may also be made available under the following Secondary
* Licenses when the conditions for such availability set forth in the Eclipse
* Public License v. 2.0 are satisfied: GNU General Public License, version 2
* with the GNU Classpath Exception which is available at
* https://www.gnu.org/software/classpath/license.html.
*
* SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
********************************************************************************/

.theia-test-view {
    height: 100%
}

.theia-test-view .passed,
.theia-test-run-view .passed {
    color: var(--theia-successBackground);
}

.theia-test-view .failed,
.theia-test-run-view .failed {
    color: var(--theia-editorError-foreground);
}

.theia-test-view .errored,
.theia-test-run-view .errored {
    color: var(--theia-editorError-foreground);
}

.theia-test-view .queued,
.theia-test-run-view .queued {
    color: var(--theia-editorWarning-foreground);
}

.theia-test-result-view .debug-frame {
    white-space: pre;
}

.theia-test-view .theia-TreeNode:not(:hover):not(.theia-mod-selected) .theia-test-tree-inline-action {
    display: none;
}`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/test/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;gFAagF;;AAEhF;IACI;AACJ;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/******************************************************************************\n* Copyright (C) 2023 STMicroelectronics and others.\n* This program and the accompanying materials are made available under the\n* terms of the Eclipse Public License v. 2.0 which is available at\n* http://www.eclipse.org/legal/epl-2.0.\n*\n* This Source Code may also be made available under the following Secondary\n* Licenses when the conditions for such availability set forth in the Eclipse\n* Public License v. 2.0 are satisfied: GNU General Public License, version 2\n* with the GNU Classpath Exception which is available at\n* https://www.gnu.org/software/classpath/license.html.\n*\n* SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n********************************************************************************/\n\n.theia-test-view {\n    height: 100%\n}\n\n.theia-test-view .passed,\n.theia-test-run-view .passed {\n    color: var(--theia-successBackground);\n}\n\n.theia-test-view .failed,\n.theia-test-run-view .failed {\n    color: var(--theia-editorError-foreground);\n}\n\n.theia-test-view .errored,\n.theia-test-run-view .errored {\n    color: var(--theia-editorError-foreground);\n}\n\n.theia-test-view .queued,\n.theia-test-run-view .queued {\n    color: var(--theia-editorWarning-foreground);\n}\n\n.theia-test-result-view .debug-frame {\n    white-space: pre;\n}\n\n.theia-test-view .theia-TreeNode:not(:hover):not(.theia-mod-selected) .theia-test-tree-inline-action {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
